import parsePhoneNumberFromString, {
  isPossiblePhoneNumber,
} from 'libphonenumber-js';

export const sanitizePhoneNumber = (phone: string): string => {
  const usNumber = isPossiblePhoneNumber(phone, 'US')
    ? parsePhoneNumberFromString(phone, 'US')
    : undefined;

  if (usNumber?.isValid()) {
    return usNumber.number;
  }

  return `+${phone.replace(/[^\d]/g, '')}`;
};
